import React, { useEffect } from 'react';
import { casebattlesStore } from '@/stores/casebattles.store';
import { useSubscription } from '@/utils/hooks/use-subscription';
import { ICaseBattleGame, ITeam } from '@/utils/types/ICaseBattle';
import { ICaseBattlePlayer, IRoll } from '@/utils/types/ICaseBattlePlayer';
import { BATTLE_LIFETIME } from '@/utils/constants';
import userStore from '@/stores/user.store';

interface Props {
    children: React.ReactNode;
}

const BattlesLayout = ({ children }: Props) => {
    const {
        addParticipant,
        loadActiveGames,
        loadHistoryGames,
        clear,
        getCases,
        addGame,
        addRoll,
        startGame,
        setWinnerByGameId,
    } = casebattlesStore((state) => state);

    useEffect(() => {
        loadActiveGames().then(() => {
            loadHistoryGames().then();
        });
        getCases().then();

        return clear();
    }, []);

    useSubscription('casebattleCreated', (game: { casebattle: ICaseBattleGame }) => {
        addGame(game.casebattle);
    }).then();

    useSubscription(
        'casebattleJoined',
        (game: {
            casebattle: ICaseBattleGame;
            team: ITeam;
            teamParticipant: ICaseBattlePlayer;
        }) => {
            // console.log('Joined', game);
            addParticipant(game.team, game.teamParticipant, game.casebattle.id);
        }
    ).then();

    useSubscription(
        'casebattleNextRoll',
        (game: { casebattle: ICaseBattleGame; rolls: IRoll[] }) => {
            addRoll(game.rolls, game.casebattle.id);
        }
    ).then();

    useSubscription('casebattleStarted', (game: { casebattle: ICaseBattleGame }) => {
        startGame(game.casebattle.id);
    }).then();

    useSubscription('casebattleFinished', ({ casebattle, teamWinner, teams, teamsWinners }) => {
        setWinnerByGameId(casebattle.id, teamsWinners);

        setTimeout(() => {
            // deleteGame(casebattle.id);
            loadHistoryGames().then();
        }, BATTLE_LIFETIME * 1000);
    }).then();

    return <>{children}</>;
};

export default BattlesLayout;
